// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import WhatsAppOutlinedSvg from "@fishx/icons-svg/es/asn/WhatsAppOutlined";
import FishxIcon from '../components/FishxIcon';

var WhatsAppOutlined = function WhatsAppOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: WhatsAppOutlinedSvg
  }));
};

WhatsAppOutlined.displayName = 'WhatsAppOutlined';
export default React.forwardRef(WhatsAppOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/WhatsAppOutlined.js
// module id = 4408
// module chunks = 0